import React, {useState, useEffect} from 'react';
import {Row, Col, Button, Modal}    from 'react-bootstrap';
import Navigation    from './components/Navigation';
import Sidebar       from './components/Sidebar';
import MainCabin     from './MainCabin';
import MainLift      from './MainLift';
import MainModels    from './MainModels';
import MainInfo      from './MainInfo';
import Cartiglio     from './components/Cartiglio';
import defaultconfig from './components/config/defaultlift.json';
import {List}        from 'react-bootstrap-icons';
import {ConfigCalculation, BillCalculation} from './utility/BillCalculator'
import './App.css';

function isJson(str){
  try { JSON.parse(str);} 
  catch (e) { return false;}
  return true;
}  

const hasWindow = typeof window !== 'undefined';

function getWindowDimensions() {
  const width = hasWindow ? window.innerWidth : null;
  const height = hasWindow ? window.innerHeight : null;
  return {
    width,
    height,
  };
}

export default function App() {

  const liftConfigStr = localStorage.getItem("liftconfig")
 
  const [liftConfig, setLiftConfig] = useState(liftConfigStr ? JSON.parse(liftConfigStr): defaultconfig )
  const [mode, setMode] = useState('MODELS')
  const [refresh, setRefresh ] = useState(Math.random());
  const [showConfirm, setShowConfirm] = useState(false);
  const [showOldVersion, setShowOldVersion] = useState(false);
  const [openfloorsection, setOpenfloorsection] = useState(false);

  const [calcConfig, setCalcConfig] = useState(ConfigCalculation(liftConfig));
  const [billConfig, setBillConfig] = useState(BillCalculation(calcConfig));

  const [wdim, setWdim] = useState(getWindowDimensions());

  const handleResize = ()=>{
    setWdim(getWindowDimensions());
  }

  const handleSetLiftConfig = config=>{
    
    if(config===null || config === undefined || Object.keys(config).length<=0)return;

    setLiftConfig( isJson(config)?JSON.parse(config):config );
    setCalcConfig( ConfigCalculation(config) );
    setBillConfig( BillCalculation(calcConfig) );

    setRefresh(Math.random())
    if(mode==='MODELS'){
      setOpenfloorsection( true );
      setMode('LIFT');
    }
  }                                               

  useEffect(()=>{
    localStorage.setItem("liftconfig", JSON.stringify(liftConfig))
  }, [liftConfig])
  
  
  window.addEventListener('resize', handleResize)

  const reset = ()=>{
    setShowConfirm( false );
    handleSetLiftConfig( defaultconfig );
    /*localStorage.removeItem("liftconfig")
    liftConfig = defaultconfig*/
  }


  let rendering
  const wrongresolution = ( wdim.width < 1280 || wdim.height<768 );

  if( wrongresolution ){
    rendering = <div className='wrong-resolution'><p>The configurator works only</p><p>on <b><i>tablet</i></b> or <b><i>desktop</i></b>  with a resolution</p><p>greater than <b><i>1280x768</i></b></p><p>in landscape mode.</p></div>
  }
  else
  if(mode==='CABIN'){
      rendering = <>
                    <MainCabin config={liftConfig} updateConfig={handleSetLiftConfig} refresh={refresh}/>
                    <Cartiglio config={liftConfig} refresh={refresh}/>
                  </>                    
  }
  else 
    if(mode==='LIFT'){
      rendering = <>
                    <MainLift config={liftConfig} updateConfig={handleSetLiftConfig} refresh={refresh} openFloorSection={openfloorsection}/>      
                    <Cartiglio config={liftConfig} refresh={refresh}/>
                  </>                    

    }
    else
    if(mode==='MODELS'){
      rendering = <MainModels config={liftConfig} select={handleSetLiftConfig} refresh={refresh}/>
    }

    else
    if(mode==='INFO'){
      rendering = <MainInfo  config={liftConfig} billconfig={billConfig} refresh={refresh}/>
    }

return(
    <>
      <Navigation mode={mode} model={liftConfig.lift.model} reset={setShowConfirm} isValid={!wrongresolution}/>
      <Row className='h100-no-overflow'>
        <Col xs={1} md={1}>
          <Button className='d-xs-block d-md-none'>
            <List className='text-white'/>
          </Button>
          {!wrongresolution?
          <Sidebar handleclick={setMode} mode={mode}/>
          :null}
        </Col>
        <Col  xs={11} md={11} className='bg-leggera' style={{height: '100%!important'}}>
          {rendering}
        </Col>
      </Row>
      <footer className='leggera-footer'>leggera configurator ver. 1.2.1-2809 - powered by <i><a href='https://www.espertia.com'> espertia srl</a>&nbsp;&nbsp;</i></footer>

      <Modal show={showConfirm||showOldVersion} onHide={e=>{setShowConfirm(false); setShowOldVersion(false)}}>
          <Modal.Header closeButton on>
            {showConfirm?
              <Modal.Title>WARNING</Modal.Title>:
              <Modal.Title>WARNING</Modal.Title>
            }
          </Modal.Header>
          
          {showConfirm?
            <Modal.Body>
              <p>Attention: All customization will be lost</p>
              <p>Are you sure?</p>
            </Modal.Body>:
            <Modal.Body>
              <p>Infromation: The last saved configuration is an old version.</p>
              <p>Reset to defaults value are madatory.</p>
              <p>We are apogized for incovenient.</p>
            </Modal.Body>
          }
        
          
          <Modal.Footer>
              <Button variant="secondary" onClick={e=>setShowConfirm(false)}>Cancel</Button>
              <Button variant="primary" onClick={reset}>Reset</Button>
          </Modal.Footer>
      </Modal>

    </>
  )
}
